import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        height: 60,
        backgroundColor: "#373b4d",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
      <h5
        className="footer-text"
        style={{
          fontWeight: 400,
          marginTop: 0,
          marginBottom: 0
        }}>
        STARNEX Network Pvt. Ltd. - India ©2023 All Rights Reserved
      </h5>
    </div>
  );
};

export default Footer;
